import { gql } from '@apollo/client'

export default gql`
  query GetCurrentSeason {
    getApostleMintInfo {
      mintInfo {
        seasonID
        seasonMintType
      }
    }
  }
`
